
import { head, includes, pathOr, split, find } from 'ramda';
import { timeStampInISOFormat } from 'src/utilities/formatDate';
import { isNotEmpty } from 'src/utilities/hasValue';


export const mkStatus = (phase: string, message: string, reason: string) => {
  return {
    phase,
    message,
    reason,
    conditions: mkConditions(null),
  };
};
const mkConditions = (condition: any) => condition ?? (condition || []);
export const mkCondition = (
  condition_type: string,
  reason: string,
  message: string,
  status: string | boolean,
  submitted_by?: string | undefined
) => {
  return {
    submitted_by,
    condition_type,
    message,
    reason,
    status,
    last_update_time: timeStampInISOFormat(),
    last_transition_time: '',
    last_probe_time: '',
  };
};

export const hasConditionValidator = (
  conditionToCheck: any,
  conditions: any
) => {
  return isNotEmpty(
    find(
      (condition: any) =>
        (includes(pathOr('', ['message'], condition), conditionToCheck) || includes(head(split(".", pathOr('', ['condition_type'], condition))), conditionToCheck)),
      conditions
    )
  );
};



export const hasConditionCompletedWithPhase = (
  conditionToCheck: any,
  loanStatus: any
) => {
  return includes(pathOr('', ['status', 'phase'], loanStatus), conditionToCheck)
}
  
